import Vue from 'vue';
import Vuex from 'vuex'
import people from "./modules/people";
import auth from "./modules/auth";
import invoices from './modules/invoices';

Vue.use(Vuex);

export default new Vuex.Store({modules: {people, auth, invoices}});
